module.exports = __webpack_public_path__ + "img/sensotex_lg.d9c0585.webp";